import Modal from '@mui/material/Modal'

export interface IConfirmFilterModalProps {
  isConfirmFilterModalOpen: boolean
  closeConfirmFilterModal: () => void
  closeModal: () => void
  applyFilter: () => void
  reloadStateFromReduxStore: () => void
}

const ConfirmFilterModal = ({
  isConfirmFilterModalOpen,
  closeConfirmFilterModal,
  closeModal,
  applyFilter,
  reloadStateFromReduxStore
}: IConfirmFilterModalProps) => {
  return (
    <Modal
      className='flex flex-col items-center justify-center'
      open={isConfirmFilterModalOpen}
      onClose={(_event: React.SyntheticEvent, reason: string) => {
        if (reason !== 'backdropClick') {
          closeConfirmFilterModal()
        }
      }}
    >
      <div className='border-2 bg-white'>
        <div className='flex flex-col justify-between gap-y-4 p-3'>
          <div className='flex justify-center font-semibold text-gray-700'>
            Do you wish to apply the changes?
          </div>
          <div className='flex w-full justify-center'>
            <div className='grid grid-cols-2 gap-2'>
              <button
                className='w-24 py-2 font-semibold text-gray-700'
                onClick={() => {
                  // resets local filter to previously applied local filter
                  reloadStateFromReduxStore()
                  closeConfirmFilterModal()
                  closeModal()
                }}
              >
                NO
              </button>
              <button
                className={[
                  'w-24 py-2',
                  'rounded bg-lighthouseBlue',
                  'font-semibold text-white'
                ].join(' ')}
                onClick={() => {
                  closeConfirmFilterModal()
                  applyFilter()
                }}
              >
                YES
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmFilterModal
